interface LanguageDictionary {
  [language: string]: string;
}
export function LanguageDictionaryFactory(source: any): LanguageDictionary {
  const q: any = {};
  if (source) {
    for (const lang in source) {
      if (source[lang]) {
        const s = source[lang] as string;
        q[lang] = s.split("\n");
      }

    }
  }
  return q;
}

export class Answer {
  Code: string;
  Text: LanguageDictionary;
  DestinationCode: string;
  Selected: boolean;
  DestinationResolver: () => Question | EndResult;
}

export class Question {
  Type: string;
  Code: string;
  Title: LanguageDictionary;
  Text: LanguageDictionary;
  Info: LanguageDictionary;
  Answers: Answer[];
  PreText: LanguageDictionary;
  FootNote: LanguageDictionary;
  Next: () => Question | EndResult;
}

export class EndResult {
  Type: string;
  Code: string;
  Text: LanguageDictionary;
  Info: LanguageDictionary;
  IsPositive: boolean;
}